import { render, staticRenderFns } from "./param-editor.vue?vue&type=template&id=38b6cec2&scoped=true"
import script from "./param-editor.vue?vue&type=script&lang=js"
export * from "./param-editor.vue?vue&type=script&lang=js"
import style0 from "./param-editor.vue?vue&type=style&index=0&id=38b6cec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6cec2",
  null
  
)

export default component.exports